module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/4-4cee519f4c3e681e31e4dfd461956e52.png";